import {Component, EventEmitter, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
    selector: 'app-dialog',
    templateUrl: 'table-fields-dialog.component.html',
    standalone: false
})
export class TableFieldsDialogComponent {

  onAdd = new EventEmitter();
  onSelectAllEv = new EventEmitter();
  onMoveEv = new EventEmitter();
  cancelEv = new EventEmitter();
  saveEv = new EventEmitter(); // I want to send data to parent component only once, user makes all the selections and when
  // clicks save we send the data to parent component

  constructor(
    public dialogRef: MatDialogRef<TableFieldsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  onColumnChecked(column: any) {
    this.data.columns.forEach(element => {
      if (element.name === column.name) {
        element.selected = !element.selected;
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save(): void {
    // when user click Save, send initial data back to parent component
    this.saveEv.emit(this.data.columns);
    this.dialogRef.close();
  }

  cancel(): void {
    this.cancelEv.emit([]); // could be anything instead of []
    this.dialogRef.close();
  }

  onChangeSelectAll(event) {
    this.onSelectAllEv.emit(event.checked);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.data.columns, event.previousIndex, event.currentIndex);
    this.onMoveEv.emit(this.data.columns);
  }


}
